import { Amplify } from 'aws-amplify';
import { Environment } from 'src/const/constants';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId:
        process.env.REACT_APP_API_ENV === Environment.LOCAL
          ? 'local_1TGJtB8x'
          : process.env.REACT_APP_API_ENV === Environment.STAGING
            ? 'us-west-1_RTwDQf8la'
            : process.env.REACT_APP_API_ENV === Environment.PROD
              ? 'us-east-2_nxU1rv6ma'
              : 'undefined',
      userPoolClientId:
        process.env.REACT_APP_API_ENV === Environment.LOCAL
          ? /* cspell:disable-next-line */
            '1xw5i7071pkyplqijmknl1179'
          : process.env.REACT_APP_API_ENV === Environment.STAGING
            ? '4cc5nac7nq5r480ho1n8viv73b'
            : process.env.REACT_APP_API_ENV === Environment.PROD
              ? /* cspell:disable-next-line */
                '5rape27ni061fp8jjjk2hndhj1'
              : 'undefined',
      ...(process.env.REACT_APP_API_ENV === Environment.LOCAL && {
        userPoolEndpoint: 'http://localhost:9229/',
      }),
    },
  },
});
